"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const ListItem_1 = __importDefault(require("./ListItem"));
const ListItemButton = (0, styled_1.default)(ListItem_1.default)({
    '&:hover, &:active': {
        borderRadius: '6px',
        cursor: 'pointer'
    }
}, ({ theme }) => ({
    '&:hover, &:active': {
        backgroundColor: theme.palette.colors.antiFlash,
        color: theme.palette.colors.midnightBlue
    }
}));
exports.default = ListItemButton;
//# sourceMappingURL=ListItemButton.js.map